import { Injectable } from '@angular/core';
import {
  MyHttpClientFactory,
  ResponseCasingEnum,
  environment,
} from '@ups/xplat/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { OfficeLocationDto } from '@ups/xplat/api/dto';

@Injectable({
  providedIn: 'root',
})
export class OfficeLocVPService {
  private vpHttp: HttpClient;

  constructor(private clientFactory: MyHttpClientFactory) {
    this.vpHttp = this.clientFactory.createHttpClient(
      environment.urls.viewpointAPI,
      true,
      ResponseCasingEnum.PascalCase
    );
  }

  getByKeyId(keyId: number) {
    return this.vpHttp.get<OfficeLocationDto>(
      `/api/quotelog/officeLocation/${keyId}`
    );
  }

  get() {
    return this.vpHttp.get<OfficeLocationDto[]>(
      `/api/quotelog/officeLocations`
    );
  }

  search(searchString: string, params: HttpParams = null, limit: number = 50) {
    params = params || new HttpParams();

    if (searchString) {
      params = params.append('searchString', searchString);
    }

    params = params.append('take', limit);
    return this.vpHttp.get<OfficeLocationDto[]>(
      '/api/quotelog/searchOfficeLocations',
      {
        params: params,
      }
    );
  }

  searchForOrgStructure(company?: number | null) {
    let params = new HttpParams().append('searchString', '');
    if (company != null) {
      params = params.append('company', company);
    }
    return this.vpHttp.get<OfficeLocationDto[]>(
      '/api/quotelog/searchOfficeLocations',
      {
        params,
      }
    );
  }
}
